import React from 'react';

export default () => {
  return (
    <p className="small" style={{ maxWidth: "80%", marginTop: "-1em", lineHeight: "1.5em" }}><strong>Síguenos</strong> en {" "}
      <a
        href="https://es-es.facebook.com/camisetascalvichi"
        target="_blank"
        rel="noopener noreferrer"
      >
        Facebook,
          </a>{" "}
      <a
        href="https://twitter.com/calvichis"
        target="_blank"
        rel="noopener noreferrer"
      >
        Twitter,
        </a>{" "}
      <a
        href="https://www.youtube.com/channel/UCxFAmNCJRC4sLEAdk1W5jGA"
        target="_blank"
        rel="noopener noreferrer"
      >
        YouTube,
        </a>
      {" "}
      <a
        href="https://www.instagram.com/calvichis/?hl=es"
        target="_blank"
        rel="noopener noreferrer"
      >
        Instagram
        </a>
      {" "} y  {" "}
      <a
        href="https://calvichis.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Mundo Calvichis.
        </a>
    </p>
  );
}

